/* eslint-disable import/max-dependencies */
import {
  takeEvery, call, put,
} from "redux-saga/effects";
import { addNotification, type Response } from "@fas/ui-framework";
import { GET_PAGE_VERSION_PREVIEW, GET_PAGE_VERSION_PREVIEW_LOADING } from "../../helpers/constants";
import DocumentApi from "../../services/documentApi";
import type { GetPageVerisionPreviewSagaAction } from "../../actions/page";
import setLoading from "../../actions/loading";
import type { PageLoadingTypes as LoadingTypes } from "../../actions/loading";

export function* makeFetch(action: GetPageVerisionPreviewSagaAction) {
  try {
    yield put(setLoading<LoadingTypes>(GET_PAGE_VERSION_PREVIEW_LOADING, true));
    const { pageId, versionId }: GetPageVerisionPreviewSagaAction = action;
    const response: { data: { data: { result: { url: string } } } } = yield call(
      DocumentApi.getPageVersionPreview,
      pageId,
      versionId
    );
    const {
      data: {
        data: {
          result: preview,
        },
      },
    } = response;
    const { url } = preview;

    window.open(url, "_blank");
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to fetch preview", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading<LoadingTypes>(GET_PAGE_VERSION_PREVIEW_LOADING, false));
  }
}

export default function* watch() {
  yield takeEvery(GET_PAGE_VERSION_PREVIEW, makeFetch);
}
